import React from 'react';
import '../css/PaperWorks.css';
import GoToTopButton from '../pages/GoToTopButton';
import ScrollProgressBar from 'react-scroll-progress-bar';

const PaperWorks = () => {
  return (
    <div className="paper-works-container">
     <iframe src="https://docs.google.com/document/d/e/2PACX-1vTIT-SeptXdgm-DcsHvbyLaocBtC8agAi3Ql6fprQhP9p8bj1k84M2wWS3rdBhnh59fSfeK-bFQEGTJ/pub?embedded=true"></iframe>




    


      <GoToTopButton />
      <ScrollProgressBar height="4px" color="#007bff" duration="0.2" />



    </div>
  );
}

export default PaperWorks;
